// 俄罗斯
module.exports = {
  common: {
    edit: "рэдагаваць",
    apply: "Ужыць",
    activate: "актывацыя",
    delete: "выдаліць",
    cancel: "Адмена",
    success: "поспех",
    fail: "няўдача",
    save: "захаваць",
    ensure: "Вядома",
    submit: "адправіць",
    remark: "Заўвага",
    detail: "Праверыць",
    action: "працаваць",
    open: "адкрыты",
    close: "закрыццё",
    back: "вяртанне",
    export: "экспарт",
    modify: "Перагляд",
    layout: "выйсці",
    noListData: "У спісе няма дадзеных",
    more: "Падрабязнасці",
    add: "Дадаць",
    delSuccess: "паспяхова выдалены!",
    addFailure: "не атрымалася дадаць!",
    logOut: "выйсці",
    delAllInfo: "Вы хочаце працягнуць аперацыю выдалення?",
    saveTip: "Вы не захавалі змесціва старонкі, хочаце працягваць выходзіць?",
    tip: "падказка",
    yes: "так",
    no: "не",
    delTip: "Праверце, каб актываваць",
    batchDelete: "пакетнае выдаленне",
    search: "Запыт",
    permission: "Пакуль няма дазволу, калі ласка, вярніцеся",
    reset: "скід",
  },
  breadcrumbItem: {
    home: "Канфігурацыя спісу імёнаў",
    data: "Упакоўка агульнай канфігурацыі прылады",
    alarm: "Канфігурацыя зоны",
    house: "Канфігурацыя планіроўкі дома",
    name: "Канфігурацыя спісу імёнаў",
  },
  errorRes: {
    res82: "Сістэма занятая, паўтарыце спробу пазней",
  },
  openConfig: {
    title: "Агульная канфігурацыя прылады",
    version: "Версія пратаколу",
    versionTip: "Калі ласка, абярыце версію пратакола",
    checkVersion: "Версія пратаколу не можа быць пустой, абярыце яшчэ раз",
    signType: "Тып алгарытму подпісу",
    checkSignType:
      "Тып алгарытму подпісу не можа быць пустым, абярыце яшчэ раз",
    fileLabel: "Выбраць дакумент",
    addFile: "дадаць файлы",
    fileName: "імя файла",
    zipType: "Метад сціску",
    noZip: "без сціску",
    noFile: "Файлы яшчэ не дададзены",
    checkFile: "Файл канфігурацыі пусты, калі ласка, дадайце файл",
    name: "імя",
    nameTip: "Даўжыня ўводу складае 1-10 лічбаў",
    checkName: "Імя не можа быць пустым, калі ласка, увядзіце паўторна",
    checkName1: "Няправільнае імя, увядзіце яго яшчэ раз",
    room: "ID прылады",
    roomTip:
      "Уваходная даўжыня складае 1-24 біта, а ўзровень адрозніваецца знакам " -
      "",
    checkRoom:
      "Нумар прылады не можа быць пустым, калі ласка, увядзіце паўторна",
    checkRoom1: "Уведзены няправільны нумар прылады, увядзіце яго яшчэ раз",
    pic: "малюнак",
    add: "Дадаць у",
    reset: "скід",
    picTip: "Максімальны памер загружанага файла малюнка - 3 м",
    checkPic: "Файл выявы не можа быць пустым, выберыце яшчэ раз",
    imgRegTip: "Загружаць файлы толькі ў фарматах jpg, jpeg, png",
    excRegTip: "Загружаць файлы толькі ў фармаце xls і xlsx",
    zipRegTip: "Загружаць файлы толькі ў фармаце zip",
    produce: "Стварыць файл канфігурацыі",
    confType: "Тып канфігурацыі",
    pack: "Пакет",
    batchAdd: "Пакетнае даданне",
    singleAdd: "Адзіночнае даданне",
    modelBatch: "Спампаваць шаблон пакетнага імпарту",
    uploadInfo: "Загрузіць асноўную інфармацыю Excel",
    uploadPic: "Загрузіць пакет малюнкаў Zip",
    addName: "Дадаць адзіную частку дадзеных",
    sameTip: "Серыйны нумар:",
    sameTip1: "Дублікат нумара прылады",
    modelError:
      "Змест загружанага файла з базавай інфармацыяй няправільны, змяніце файл у адпаведнасці з шаблонам",
    noPic:
      "У спісе ёсць даныя, якія не былі дададзены разам з малюнкамі, вам неабходна завяршыць малюнкі перад стварэннем файла канфігурацыі",
    picBtnTip: "Калі ласка, спачатку загрузіце файл асноўнай інфармацыі",
    devType: "Тып абсталявання",
    devTypeTip: "Калі ласка, абярыце тып прылады",
    checkDevType: "Тып прылады не можа быць пустым, абярыце яшчэ раз",
    indexName: "серыйны нумар",
    IS: "Унутраны блок",
    GU: "Машына кіравання",
    OS1: "Галасавая станцыя",
    OS2: "Сценная машына",
    OS3: "Станцыя дзвярэй",
    nameListTip:
      "У загружаных базавых даных ёсць даныя з няпоўным полем імя, а астатнія правільныя даныя былі імпартаваныя",
    numListTip:
      "У загружаных базавых даных ёсць няпоўныя даныя ў полі нумара прылады, а астатнія правільныя даныя былі імпартаваныя",
  },
  alarm: {
    ad: "зона AD",
    io: "зона IO",
    alarmPlus: "Пашырэнне зоны",
    num: "серыйны нумар",
    open: "адкрыты",
    close: "блізка",
    machine: "Тып дэтэктара",
    sendType: "Тып трыгера",
    mode: "мадэль",
    mType1: "інфрачырвоны",
    mType2: "Дзверы магнітныя",
    mType3: "аконны магніт",
    mType4: "газ",
    mType5: "дым",
    mType6: "дзвярны званок",
    mType7: "Кнопка рассылкі",
    mType8: "Інфрачырвоны дзвярны датчык",
    mType9: "Дзвярны датчык сігналізацыі",
    mType10: "вібрацыя",
    mType11: "ціск паветра",
    mType12: "іншы",
    send1: "Паведаміць неадкладна на працягу 24 гадзін",
    send2: "Адкладзены будзільнік",
    send3: "Затрымка перадачы",
    send4: "Неадкладна выклікайце паліцыю",
    send5: "Крыжовая трывога",
    mode1: "Нармальна адкрыты",
    mode2: "Часта выключаны",
    presence: "дома",
    leaving: "пакідаючы дом",
    timeSet: "Настройка часу, звязаная з рукой",
    delayTime: "Эфектыўная затрымка пастаноўкі на ахову (секунды)",
    startDelay: "Затрымка спрацоўвання будзільніка (секунды)",
    startUtil: "Працягласць будзільніка (хвілін)",
    associated: "Дапаможная зона",
  },
  house: {
    dev: "абсталяванне",
    scene: "Сцэны",
    vine: "датчык",
    single: "Самастойны кантроль сцэн",
    light: "святло",
    air: "кандыцыянер",
    heat: "цёплая падлога",
    fresh: "Свежы вецер",
    switch: "Разетка выключальніка",
    curtain: "заслона",
    water: "воданагравальнік",
    bgm: "Фонавая музыка",
    cust: "Карыстальніцкая прылада",
    slight: "святло",
    sAir: "кандыцыянер",
    sHeat: "цёплая падлога",
    sFresh: "Свежы вецер",
    sSwitch: "Разетка выключальніка",
    sCurtain: "заслона",
    sWater: "воданагравальнік",
    sBgm: "Фонавая музыка",
    sCust: "Карыстальніцкая прылада",
    IndependentControl: "Самастойны кантроль сцэн",
    scene1: "сцэна 1",
    scene2: "Сцэна 2",
    scene3: "Сцэна 3",
    scene4: "Сцэна 4",
    scene5: "Сцэна 5",
    scene6: "Сцэна 6",
    scene7: "Сцэна 7",
    scene8: "Сцэна 8",
    temp1: "тэмпература",
    temp2: "вільготнасць",
    temp3: "метан",
    temp4: "арганічны газ",
    picTip: "Няма плана паверха",
    upload: "Загрузіць план паверха",
    imgSize: "Памер выявы плана аднаго паверха не павінен перавышаць 10 МБ",
    imgName:
      "Назва загружанага файла плана паверха не павінна з'яўляцца на кітайскай мове, выберыце яшчэ раз",
    imgLength:
      "Агульная колькасць загрузак і дапаўненняў планаў паверхаў не павінна перавышаць 8, і першыя 8 малюнкаў у тэчцы былі выбраны аўтаматычна",
    imgCheckTip: "План паверха не супадае, загрузіце паўторна",
    room1: "Дом тыпу 1",
    room2: "Дом тыпу 2",
    room3: "Тып дома 3",
    room4: "Дом тыпу 4",
    room5: "Дом тыпу 5",
    room6: "Дом тыпу 6",
    room7: "Дом тыпу 7",
    room8: "Тып дома фігура 8",
    download: "экспарт",
    input: "Імпарт канфігурацыі",
    title: "Табліца параметраў абсталявання",
    name: "імя",
    location: "Месцазнаходжанне",
    start: "запуск",
    see: "бачны",
    noSee: "Нябачны",
    belong: "належыць",
    bgIcon: "Сіне-шэры значок",
    vineTip:
      "Калі ласка, выберыце план паверха, перш чым наладжваць параметры кантролю тэмпературы",
    sceneTip:
      "Калі ласка, выберыце план паверха, а затым задайце ўласцівасці сцэны",
    dragTip:
      "Калі ласка, абярыце план паверха перад выкананнем аперацыі перацягвання",
    editTip: "Паспяхова адрэдагавана",
    addTip: "Пры загрузцы трэба выбраць усе планы паверхаў адразу",
    editError: "Калі ласка, укажыце змесціва рэдагавання перад рэдагаваннем",
    delError: "Калі ласка, укажыце змесціва для выдалення перад выдаленнем",
    delTip: "паспяхова выдалены",
    imgAddTip:
      "Агульная колькасць запампаваных і дададзеных планаў паверхаў дасягнула 8, больш нельга дадаваць",
    houseTitle: "Пераключэнне карты тыпу дома:",
    delHouseTip:
      "Гэтая аперацыя выдаліць план паверха і змесціва канфігурацыі. Вы хочаце працягнуць?",
    sendTip:
      "Імпартуйце змесціва канфігурацыі для паўторнага змянення, вы можаце загрузіць файл xml",
    checkType:
      "Фармат загружанага файла няправільны, калі ласка, праверце змесціва файла і загрузіце яшчэ раз",
    importTip: "Імпартаваць файл канфігурацыі",
    importTip1: "Імпартаваць адпаведны план паверха",
    upLoadBtn: "Загрузіць",
    picContent:
      "Парадак загрузкі планаў паверхаў павінен адпавядаць парадку планаў паверхаў у файле канфігурацыі",
    successFile: "Файл канфігурацыі паспяхова запампаваны",
    vineTipCheck: "Імя не можа быць пустым, калі ласка, пацвердзіце ўвод",
    picNumMax:
      "Калі ласка, пацвердзіце колькасць імпартаваных малюнкаў. Бягучая колькасць імпартаваных малюнкаў перавышае колькасць планаў дамоў у файле канфігурацыі. Калі ласка, абярыце яшчэ раз",
    picNumMin:
      "Калі ласка, пацвердзіце колькасць імпартаваных малюнкаў. Бягучая колькасць імпартаваных малюнкаў меншая за колькасць планаў дамоў у файле канфігурацыі. Выберыце яшчэ раз",
    maxSizeTip:
      "Колькасць або агульная колькасць дапаўненняў гэтага тыпу перавышае ліміт. Калі вам трэба дадаць, спачатку адсартуйце дададзеныя прылады або сцэны.",
    devNameTip: "Калі ласка, увядзіце імя",
    chromeTip: "Рэкамендуецца браўзер Chrome",
    downTip: "Націсніце, каб перайсці па спасылцы для загрузкі",
    imgRegTip: "Загружаць файлы толькі ў фарматах jpg і jpeg",
    threeTitle: "Трохканстантная сістэма",
    mainControl: "майстар",
    sedControl: "субкантроль",
    controlBtn: "Канфігурацыя",
    configEdit: "Падрабязнасці канфігурацыі сістэмы Sanheng",
    moveTip:
      "Калі ласка, перацягніце значок у вобласць плана паверха, перацягніце яго яшчэ раз",
    repeatNameTip:
      "Немагчыма загрузіць планы паверхаў з такой жа назвай, абярыце яшчэ раз",
    space: "(Зарэзервавана)",
  },
  updateConfig: {
    tip0: "Калі ўсталёўваеце 24-гадзінны будзільнік, усталюйце пераключальнік у становішча ON",
    tip1: "Пры ўсталёўцы 24-гадзіннага будзільніка пераключальнік павінен быць уключаны",
    tip2: "Пры ўсталёўцы неадкладнай сігналізацыі пераключальнік павінен быць уключаны",
    tip3: "Калі сігналізацыя аб затрымцы выключана, затрымку дастаўкі трэба выключыць",
    tip4: "Усталяваны перакрыжаваны сігнал трывогі, патрэбна адпаведная аперацыя",
    tip5: "Спачатку ўключыце будзільнік з затрымкай",
    tip6: "Пры ўсталёўцы неадкладнай сігналізацыі ўключыце пераключальнік",
  },
  audio: {
    title: "Инструмент упаковки звуковых подсказок",
    lock: "Звук разблокировки",
    call: "Звук вызова",
    speak: "Звук разговора",
    busy: "Занятый сигнал",
    tip1: "Щелкните, чтобы загрузить файл в формате .wav",
    tip2: "Размер файла не должен превышать 1 МБ",
    tip3: "Загрузите файл в формате .wav, пожалуйста",
    tip4: "Пожалуйста, загрузите все файлы",
    add: "Создать файлы",
  },
  threeProject: {
    hotWater: "Система Горячей Воды",
    cho: "Формальдегид",
    config: "Настроить",
    unconfig: "Не настраивать",
  },
  elevator: {
    title: "Генератор конфигурации системы контроля лифта",
    label: "Загрузить таблицу конфигурации системы контроля",
    uploadTip: "Нажмите или перетащите файл в эту область для загрузки",
    upload: "Загрузить",
    download: "Скачать шаблон",
    downloadTip:
      "Нажмите, чтобы скачать шаблон таблицы конфигурации системы контроля",
    error1:
      "[Физический этаж] указан неверно. Проверьте файл конфигурации и импортируйте снова.",
    error2:
      "[Отображаемый этаж] указан неверно. Проверьте файл конфигурации и импортируйте снова.",
    error3:
      "[Адрес шлюза системы контроля] указан неверно. Проверьте файл конфигурации и импортируйте снова.",
    error4:
      "[Отображение номера лифта] указано неверно. Проверьте файл конфигурации и импортируйте снова.",
    error5:
      "[IP-адрес устройства] указан неверно. Проверьте файл конфигурации и импортируйте снова.",
    error6:
      "[Шлюз системы контроля] превысил лимит количества. Проверьте файл конфигурации и импортируйте снова.",
    generate: "Шаблон таблицы конфигурации системы контроля",
    fileLabel: "Файл конфигурации системы контроля:",
    tip: "Поместите файл конфигурации в раздел [Обновление ресурсов] ПК-инструмента для импорта в устройство.",
    downloadfile: "Скачать",
    fileName: "КонфигурацияСистемыКонтроляЛифта.xlsx",
    formatError:
      "Неверный формат загруженного файла. Проверьте содержимое файла и загрузите его снова",
  },
};
